module.exports = __webpack_public_path__ + "static/iwantthekit-bb3370adce8373344003ea350a0168cd.png";